import React from 'react';

export default function Reactor7Icon({
  width = 64,
  height = 100,
  startColor = '#1E1E1E',
  midColor = '#EBEBEB',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 72.029 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_BackLegs">
	<path fill="#323232" d="M56.811,70.453L39.258,86.147L21.642,70.453h-4.058v39.227h4.058v-5.846l17.593-15.621l17.576,15.617v5.85   h4.059V70.453H56.811z M21.642,72.582c0.005,0.002,16.403,14.576,16.403,14.576l-16.403,14.526V72.582z M56.811,101.639   L40.421,87.176l16.391-14.566V101.639z" />
</g>
<g id="Group_TankBody">
	
		<radialGradient id={`${id}_1_`} cx="39.2273" cy="83.1904" r="26.3172" gradientTransform="matrix(1 0 0 1.9 0 -74.8714)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.14" style={{stopColor: "#DCDCDC"}} />
		<stop offset="0.4" style={{stopColor: "#B7B7B7"}} />
		<stop offset="0.75" style={{stopColor: "#7B7B7B"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_1_)`} d="M32.238,100.775h14.091l25.7-35.17H6.426L32.238,100.775" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="6.4255" y1="42.1592" x2="72.0291" y2="42.1592">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.49" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.56" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.71" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.92" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M72.029,65.609v-46.9H6.426v46.9" />
	
		<radialGradient id={`${id}_3_`} cx="39.2273" cy="11.6689" r="23.7233" gradientTransform="matrix(1 0 0 1.2 0 -2.3338)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.03" style={{stopColor: "#E4E4E4"}} />
		<stop offset="0.37" style={{stopColor: "#A3A3A3"}} />
		<stop offset="0.66" style={{stopColor: "#747474"}} />
		<stop offset="0.88" style={{stopColor: "#565656"}} />
		<stop offset="1" style={{stopColor: "#4C4C4C"}} />
	</radialGradient>
	<path fill={`url(#${id}_3_)`} d="M72.029,18.714l-25.7-14.09H32.238L6.426,18.714" />
	<path fill="none" stroke="#7F7F7F" strokeWidth="0.25" d="M32.238,41.596V18.714h0.563v22.882" />
	<path fill="none" stroke="#7F7F7F" strokeWidth="0.25" d="M70.901,18.15H7.552l-1.127,0.563h65.604v22.882H6.426v0.563h65.604   v22.882H6.426v0.563h65.604l-43.962-0.563V42.16h0.677v22.882" />
</g>
<g id="Group_FrontLegs">
	<path fill="#989898" d="M55.684,65.609v2.363h11.723v-2.363H55.684z" />
	<path fill="#989898" d="M11.047,65.605v2.367h11.723v-2.367H11.047z" />
	<path fill="#7E7E7E" d="M59.178,67.973v44.525h4.734V67.973H59.178z" />
	<path fill="#7E7E7E" d="M14.654,67.973v44.525h4.621V67.973H14.654z" />
	<path fill="#989898" d="M60.419,65.605v46.893h2.254V65.605H60.419z" />
	<path fill="#989898" d="M15.781,65.605v46.893h2.367V65.605H15.781z" />
	<polygon fill="#7E7E7E" points="59.178,70.34 39.227,87.925 19.275,70.34 19.275,72.707 37.884,89.108 19.275,105.51    19.275,107.877 39.227,90.292 59.178,107.877 59.178,105.51 40.57,89.108 59.178,72.707  " />
</g>
<g id="Group_Ladder">
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="5.3943" y1="5.2817" x2="7.8473" y2="7.8219">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_4_)`} points="1.24,9.583 9.694,1.129 11.124,4.484 4.622,10.936  " />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="21.3455" y1="4.5112" x2="21.3455" y2="1.1294">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.1" style={{stopColor: "#666666"}} />
		<stop offset="0.27" style={{stopColor: "#ADADAD"}} />
		<stop offset="0.39" style={{stopColor: "#DADADA"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.52" style={{stopColor: "#E4E4E4"}} />
		<stop offset="0.61" style={{stopColor: "#D2D2D2"}} />
		<stop offset="0.71" style={{stopColor: "#B3B3B3"}} />
		<stop offset="0.75" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_5_)`} points="9.694,1.129 32.997,1.129 32.997,4.511 11.047,4.511  " />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="1.24" y1="60.7588" x2="4.6218" y2="60.7588">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<polygon fill={`url(#${id}_6_)`} points="1.24,9.583 4.622,10.936 4.622,111.934 1.24,111.934  " />
	<linearGradient id={`${id}_7_`} gradientUnits="userSpaceOnUse" x1="-2.441406e-004" y1="63.8584" x2="6.989" y2="63.8584">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_7_)`} d="M0,62.111h6.989v3.494H0V62.111z" />
	<linearGradient id={`${id}_8_`} gradientUnits="userSpaceOnUse" x1="-2.441406e-004" y1="41.5962" x2="6.989" y2="41.5962">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_8_)`} d="M0,39.792h6.989V43.4H0V39.792z" />
	<linearGradient id={`${id}_9_`} gradientUnits="userSpaceOnUse" x1="-2.441406e-004" y1="20.5176" x2="6.989" y2="20.5176">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_9_)`} d="M0,18.714h6.989v3.607H0V18.714z" />
</g>
<g id="Group_TBD">
	<linearGradient id={`${id}_10_`} gradientUnits="userSpaceOnUse" x1="29.8708" y1="3.4399" x2="48.5828" y2="3.4399">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.48" style={{stopColor: "#989898"}} />
		<stop offset="0.58" style={{stopColor: "#858585"}} />
		<stop offset="0.79" style={{stopColor: "#545454"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_10_)`} d="M46.329,4.624l2.254-2.367H29.871l2.367,2.367" />
	<linearGradient id={`${id}_11_`} gradientUnits="userSpaceOnUse" x1="29.8708" y1="1.1289" x2="48.5828" y2="1.1289">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.47" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.7" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.91" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_11_)`} d="M48.583,2.256V0.002H29.871v2.254" />
</g>
    
      </g>
      <rect x="0" y="0" width="72.029" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
